import { Role } from '../../enum/role.enum';
import { LoginProfileModel } from './login-profile.model';

export class LoginProfile {
  accessTokenExpiredAt: string;
  email: string;
  fullName: string;
  id: string;
  role: Role;
  // ADR-0015 / INC-263: previously dropped here — now threaded through so the login nudge fires.
  isProfileRefreshRequired: boolean;
  // ENB-70 / ADR-0027: this account holds TranslationEditor, i.e. it is a copy editor rather than a
  // customer. Carried as its own flag on purpose — `role` below is what the route guards read, and a
  // copy editor must keep leaving it undefined so no investor affordance unlocks. ENB-71 reads this
  // flag to show the copy-edit affordance.
  isTranslationEditor: boolean;
  // True when the session was opened on behalf of the investor via login-on-behalf (e.g. by a
  // Customer Service agent in a support session). Persisted by StorageService so support-only
  // affordances — like the code-less 2FA removal — can gate on it. Defaults to false for an
  // ordinary login.
  isOnBehalfSession: boolean;

  constructor(model: LoginProfileModel) {
    this.accessTokenExpiredAt = model.accessTokenExpiredAt;
    this.email = model.email;
    this.fullName = model.fullName;
    this.id = model.id;
    this.isProfileRefreshRequired = model.isProfileRefreshRequired;
    this.isOnBehalfSession = !!model.isOnBehalfSession;
    // No `?? []` here on purpose. A login payload without `roles` is a broken response, and the
    // TypeError it throws is the failure signal five callers rely on — login, loginOAuth,
    // refreshToken, verifyEmail and loginOnBehalf all construct this and immediately persist it.
    // Defaulting to [] would let the 401-refresh path "succeed" while silently wiping the session's
    // role. (Found in pre-PR review.)
    // `length === 1`, not `.some(...)`: ADR-0027 is explicit that a copy-editor account "holds
    // exactly one role", so this flag means "dedicated copy-editor account", not "TranslationEditor
    // appears somewhere in the list". It matters because login.component.ts admits `!role &&
    // isTranslationEditor` to Customer Web — under `.some(...)` an Admin+TranslationEditor account
    // resolves no investor role, so it would have been let in where plain Admin is refused.
    // Defence-in-depth: the API is what actually enforces the role is held alone. (Copilot, #1549.)
    this.isTranslationEditor =
      model.roles.length === 1 && Role[model.roles[0]] === Role.TranslationEditor;
    model.roles.forEach((r) => {
      if ([Role.IndividualInvestor, Role.CompanyRep, Role.IssuerRep].includes(Role[r])) {
        this.role = Role[r];
      }
    });
  }
}
